// src/stone/icons/Pos.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var Pos = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { fill: "currentcolor", d: "M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "currentcolor",
          fillRule: "evenodd",
          d: "M5 5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2zm10 0H7v5h8zM5.5 14a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2h-1a1 1 0 0 1-1-1M9.5 14a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2h-1a1 1 0 0 1-1-1M5.5 17a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2h-1a1 1 0 0 1-1-1M5.5 20a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2h-1a1 1 0 0 1-1-1M9.5 17a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2h-1a1 1 0 0 1-1-1M9.5 20a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2h-1a1 1 0 0 1-1-1M13.5 14a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2h-1a1 1 0 0 1-1-1M13.5 17a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2h-1a1 1 0 0 1-1-1M13.5 20a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2h-1a1 1 0 0 1-1-1",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "currentcolor",
          fillRule: "evenodd",
          d: "M2.294 2.26C2.5.853 3.727 0 5.009 0h11.982c1.282 0 2.508.852 2.715 2.26C19.856 3.278 20 4.82 20 7c0 3.252-.323 10.659-.483 14.144A2.995 2.995 0 0 1 16.524 24H5.476c-1.6 0-2.92-1.255-2.993-2.856C2.323 17.659 2 10.252 2 7c0-2.18.144-3.723.294-4.74M5.009 2c-.436 0-.694.262-.737.552C4.138 3.462 4 4.908 4 7c0 3.194.32 10.547.48 14.052.025.53.462.948.996.948h11.048c.534 0 .97-.418.995-.948C17.681 17.547 18 10.195 18 7c0-2.092-.138-3.537-.272-4.448-.043-.29-.302-.552-.737-.552z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
var Pos_default = Pos;

export {
  Pos_default
};
